// ============================================
// FILE: src/components/InquiryForm.jsx
// ============================================
import React, { useState } from 'react';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';

const InquiryForm = () => {
  const [hoveredSocial, setHoveredSocial] = useState(null);

  const contactInfo = [
    {
      icon: <Phone size={20} />,
      label: 'Phone Numbers',
      value: (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <a 
            href="tel:+919764646044" 
            className="phone-link"
            onClick={(e) => e.stopPropagation()}
          >
            +91 97646 46044
          </a>
          <a 
            href="tel:+919158636044" 
            className="phone-link"
            onClick={(e) => e.stopPropagation()}
          >
            +91 91586 36044
          </a>
        </div>
      ),
      href: null,
    },
    {
      icon: <Mail size={20} />,
      label: 'Email Address',
      value: 'saipropertiesandfinance@gmail.com',
      href: 'mailto:saipropertiesandfinance@gmail.com',
    },
    {
      icon: <MapPin size={20} />,
      label: 'Office Address',
      value: 'Survey No 298, Nirvana Lifecity, Office No. B-12, opposite Kohinoor Viva City, Lohegaon, Pune, Maharashtra 411047',
      href: 'https://maps.google.com/?q=Survey+No+298+Nirvana+Lifecity+Office+No+B-12+opposite+Kohinoor+Viva+City+Lohegaon+Pune+Maharashtra+411047',
    },
    {
      icon: <Clock size={20} />,
      label: 'Working Hours',
      value: 'Mon – Sat: 10:00 AM to 8:00 PM',
      href: null,
    },
  ];

  // SVG Social Icons Components
  const FacebookIcon = ({ size = 18, color = 'currentColor' }) => (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M18 2H15C13.6739 2 12.4021 2.52678 11.4645 3.46447C10.5268 4.40215 10 5.67392 10 7V10H7V14H10V22H14V14H17L18 10H14V7C14 6.73478 14.1054 6.48043 14.2929 6.29289C14.4804 6.10536 14.7348 6 15 6H18V2Z" 
        stroke={color} 
        strokeWidth="1.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );

  const InstagramIcon = ({ size = 18, color = 'currentColor' }) => (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5" 
        stroke={color} 
        strokeWidth="1.5" 
        fill="none"
      />
      <circle cx="12" cy="12" r="4" 
        stroke={color} 
        strokeWidth="1.5" 
        fill="none"
      />
      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" 
        stroke={color} 
        strokeWidth="1.5" 
        strokeLinecap="round"
      />
    </svg>
  );

  const YoutubeIcon = ({ size = 18, color = 'currentColor' }) => (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 0 0 1.46 6.42 29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58 2.78 2.78 0 0 0 1.95 1.95C5.12 20 12 20 12 20s6.88 0 8.59-.47a2.78 2.78 0 0 0 1.95-1.95A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z" 
        stroke={color} 
        strokeWidth="1.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"
        fill="none"
      />
      <polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" 
        stroke={color} 
        strokeWidth="1.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );

  const socialLinks = [
    {
      id: 'facebook',
      icon: <FacebookIcon size={18} />,
      label: 'Facebook',
      href: 'https://www.facebook.com/shreesaip/',
      color: '#1877F2',
      bg: '#E7F0FD',
    },
    {
      id: 'instagram',
      icon: <InstagramIcon size={18} />,
      label: 'Instagram',
      href: 'https://www.instagram.com/shreesaiproperties/',
      color: '#E1306C',
      bg: '#FDEAF1',
    },
    {
      id: 'youtube',
      icon: <YoutubeIcon size={18} />,
      label: 'YouTube',
      href: 'https://www.youtube.com/@shreesaiproperties1198',
      color: '#FF0000',
      bg: '#FEEBEB',
    },
  ];

  return (
    <div>
      <style>{`
        .contact-card-compact {
          background: #FFFFFF;
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 4px 24px rgba(15, 27, 76, 0.08);
          border: 1px solid #E8EBF4;
          height: auto;
        }

        .contact-card-compact-header {
          background: linear-gradient(135deg, #0F1B4C 0%, #1A3A8F 100%);
          padding: 24px 24px 20px;
        }

        .contact-card-compact-header h3 {
          font-family: 'DM Serif Display', serif;
          font-size: 20px;
          color: #FFFFFF;
          margin-bottom: 4px;
        }

        .contact-card-compact-header p {
          font-size: 12px;
          color: #93C5FD;
        }

        .contact-card-compact-body {
          padding: 4px 0;
        }

        .contact-item-compact {
          display: flex;
          align-items: flex-start;
          gap: 12px;
          padding: 14px 20px;
          text-decoration: none;
          color: inherit;
          border-bottom: 1px solid #F0F2FA;
          transition: background 0.15s ease;
          cursor: pointer;
        }

        .contact-item-compact:last-child {
          border-bottom: none;
        }

        .contact-item-compact:hover {
          background: #F7F8FC;
        }

        .contact-icon-wrap-compact {
          width: 36px;
          height: 36px;
          background: #EEF2FF;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #1A3A8F;
          flex-shrink: 0;
        }

        .contact-label-compact {
          font-size: 10px;
          font-weight: 600;
          letter-spacing: 0.08em;
          text-transform: uppercase;
          color: #6B7A99;
          margin-bottom: 2px;
        }

        .contact-value-compact {
          font-size: 13px;
          font-weight: 500;
          color: #1A1A2E;
          line-height: 1.4;
        }

        .contact-item-compact:hover .contact-value-compact {
          color: #1A3A8F;
        }

        .phone-link {
          display: inline-block;
          color: #1A1A2E;
          text-decoration: none;
          transition: color 0.15s ease;
          font-weight: 500;
          padding: 2px 0;
        }

        .phone-link:hover {
          color: #1A3A8F !important;
          text-decoration: underline;
        }

        .social-section-compact {
          padding: 16px 20px 20px;
          border-top: 1px solid #F0F2FA;
        }

        .social-label-compact {
          font-size: 10px;
          font-weight: 600;
          letter-spacing: 0.08em;
          text-transform: uppercase;
          color: #6B7A99;
          margin-bottom: 10px;
        }

        .social-links-compact {
          display: flex;
          gap: 8px;
          flex-wrap: wrap;
        }

        .social-btn-compact {
          display: flex;
          align-items: center;
          gap: 6px;
          padding: 6px 12px;
          border-radius: 8px;
          text-decoration: none;
          font-size: 12px;
          font-weight: 500;
          border: 1.5px solid transparent;
          transition: all 0.2s ease;
          cursor: pointer;
        }

        .social-btn-compact:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0,0,0,0.1);
        }
      `}</style>

      <div className="contact-card-compact">
        <div className="contact-card-compact-header">
          <h3>Contact Information</h3>
          <p>Reach us through any of these channels</p>
        </div>

        <div className="contact-card-compact-body">
          {contactInfo.map((item, i) => {
            const Tag = item.href ? 'a' : 'div';
            return (
              <Tag
                key={i}
                href={item.href}
                className="contact-item-compact"
                target={item.href?.startsWith('http') ? '_blank' : undefined}
                rel={item.href?.startsWith('http') ? 'noopener noreferrer' : undefined}
              >
                <div className="contact-icon-wrap-compact">
                  {item.icon}
                </div>
                <div>
                  <div className="contact-label-compact">{item.label}</div>
                  <div className="contact-value-compact">{item.value}</div>
                </div>
              </Tag>
            );
          })}
        </div>

        {/* Social */}
        <div className="social-section-compact">
          <div className="social-label-compact">Follow us</div>
          <div className="social-links-compact">
            {socialLinks.map((s) => (
              <a
                key={s.id}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                className="social-btn-compact"
                aria-label={s.label}
                style={{
                  background: hoveredSocial === s.id ? s.bg : '#F7F8FC',
                  color: hoveredSocial === s.id ? s.color : '#6B7A99',
                  borderColor: hoveredSocial === s.id ? s.color + '40' : '#E8EBF4',
                }}
                onMouseEnter={() => setHoveredSocial(s.id)}
                onMouseLeave={() => setHoveredSocial(null)}
              >
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  {s.icon}
                </span>
                <span>{s.label}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InquiryForm;